import React from "react";

import {Select} from "antd";

import {rankSortedSuggestions, sortOptionsNaturally} from "./suggestions";

const toText = value => (value === undefined || value === null ? "" : String(value));


const SuggestSelect = ({options, onChange, onSearch, onSelect, mode = "tags", autoClearSearchValue, ...rest}) => {
	const [typedQuery, setTypedQuery] = React.useState("");

	const sortedOptions = React.useMemo(() => sortOptionsNaturally(options), [options]);
	const rankedOptions = React.useMemo(
		() => rankSortedSuggestions(sortedOptions, typedQuery),
		[sortedOptions, typedQuery],
	);

	const handleSearch = searchText => {
		setTypedQuery(toText(searchText));
		if (onSearch) onSearch(searchText);
	};

	const handleSelect = (value, option) => {
		if (autoClearSearchValue !== false) setTypedQuery("");
		if (onSelect) onSelect(value, option);
	};

	return (
		<Select
			{...rest}
			mode={mode}
			options={rankedOptions}
			autoClearSearchValue={autoClearSearchValue}
			filterOption={false}
			onChange={onChange}
			onSearch={handleSearch}
			onSelect={handleSelect}
		/>
	);
};

export default SuggestSelect;
